import React from 'react';
import CMSImages from '@components/atoms/vc-images/components/cms-image';
import { CampaignBlock } from '@interfaces/models/campaign';
import { removeCMSImageExtensionForAlt } from '@helpers/utils/general';
import styles from '../campaign-block.module.scss';

const DEFAULT_SIZES = `
          (min-width: 1200px) 1246px,
          (min-width: 768px) 768px,
          (min-width: 420px) 420px,
          (min-width: 100px) 375px
          `;

const DEFAULT_SRC_SET = [
  { width: '375', height: '328', descriptor: '320w' },
  { width: '420', height: '367', descriptor: '420w' },
  { width: '768', height: '768', descriptor: '780w' },
  { width: '1246', height: '910', descriptor: '1246w' },
];

const HERO_SIZES = `(min-width: 1460px) 1460px, 100vw`;

const HERO_SRC_SET = [
  ...DEFAULT_SRC_SET,
  { width: '1460', height: '360', descriptor: '1460w' },
  { width: '1920', height: '473', descriptor: '1920w' },
  { width: '2560', height: '631', descriptor: '2560w' },
  { width: '2920', height: '720', descriptor: '2920w' },
];

export type CampaignImgProps = {
  className?: string;
  image: CampaignBlock['image'];
  isHeroVersion?: boolean;
};

const CampaignImg = ({ className, image, isHeroVersion = false }: CampaignImgProps) => {
  const { filename: imgXName, url: imgPath, title: imgTitle } = image || {};

  if (!imgXName || !imgPath) {
    return null;
  }

  return (
    <CMSImages
      className={styles.campaign__img}
      sizes={isHeroVersion ? HERO_SIZES : DEFAULT_SIZES}
      wrapperProps={{ className: `${styles.campaign__img__container} ${className ?? ''}` }}
      src={imgPath}
      srcSetOpts={isHeroVersion ? HERO_SRC_SET : DEFAULT_SRC_SET}
      alt={removeCMSImageExtensionForAlt(imgTitle)}
      data-src={imgXName}
      width={375}
      height={328}
      priority
      disableLazyLoad
    />
  );
};

export default CampaignImg;
